import { HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: HorizontalBar,
  data() {
    return {
      options: {
        plugins: {
          datalabels: {
            color: "orange"
          }
        },
        layout: {
          padding: {
            left: 5,
            right: 5,
            top: 5,
            bottom: 5
          }
        },
        legend: {
          display: true,
          labels: {
            boxWidth: 0,
            fontStyle: "bold",
            fontColor: "#000000",
            fontSize: 14
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                min: 0,
                max: 54,
                fontSize: 14
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                fontColor: "#000000",
                fontSize: 14
              }
            }
          ]
        }
      }
    };
  },
  mixins: [reactiveProp],

  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
